import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, THEMES } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';

// Cycles dark → light → system. The icon reflects the current CHOICE.
const ICONS = {
  [THEMES.DARK]: { Icon: Moon, cls: 'text-cyan-400', label: 'Dark' },
  [THEMES.LIGHT]: { Icon: Sun, cls: 'text-amber-500', label: 'Light' },
  [THEMES.SYSTEM]: { Icon: Monitor, cls: 'text-slate-400', label: 'System' },
};

const NEXT_LABEL = {
  [THEMES.DARK]: 'light mode',
  [THEMES.LIGHT]: 'system theme',
  [THEMES.SYSTEM]: 'dark mode',
};

const ThemeToggle = ({ className = "" }) => {
  const { theme, cycleTheme } = useTheme();
  const { Icon, cls, label } = ICONS[theme] || ICONS[THEMES.DARK];

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycleTheme}
      className={`relative w-10 h-10 rounded-full overflow-hidden ${className}`}
      data-testid="theme-toggle"
      data-automation-id="theme-toggle"
      title={`Theme: ${label}. Click for ${NEXT_LABEL[theme]}.`}
      aria-label={`Theme: ${label}. Switch to ${NEXT_LABEL[theme]}.`}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={theme}
          initial={{ rotate: -90, opacity: 0, scale: 0.5 }}
          animate={{ rotate: 0, opacity: 1, scale: 1 }}
          exit={{ rotate: 90, opacity: 0, scale: 0.5 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 flex items-center justify-center"
        >
          <Icon className={`w-5 h-5 ${cls}`} />
        </motion.div>
      </AnimatePresence>
    </Button>
  );
};

export default ThemeToggle;
